export const MN_ID = 'Minnesota';
export const WI_ID = 'Wisconsin';
export const CO_ID = 'Colorado';
export const NM_ID = 'New Mexico';
